import React from 'react';

const BrandsMinimal = () => {
  return (
    <section className="bg-black border-y border-tertiary">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm text-tertiary font-sans uppercase tracking-wider mb-4 block">
            Worldwide Partnerships
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-primary">
            Brands and Collaborations
          </h2>
        </div>

        {/* Brands Logo Banner */}
        <div className="bg-white rounded-lg px-8 py-10 lg:px-14 lg:py-14" data-testid="brands-banner">
          <img
            src="/images/brands/brands-banner.png"
            alt="Brands and collaborations — The Garnette Report, SKG, IFA, Vogue, Berlin Fashion Week, Tesla, TEDx Mitte"
            loading="lazy"
            className="w-full h-auto"
            data-testid="brands-banner-image"
          />
        </div>
      </div>
    </section>
  );
};

export default BrandsMinimal;
